<span [ngClass]="{'is-error': isError, 'is-big': isBig, 'is-gray': isGray}">
  <ng-content></ng-content>
</span>
